export default {
  // /!\ OBSOLETE : Hauteur du planning (devenu obsolète avec le flex: 1 sur le planning)
  HEIGHT: 700,
  // Hauteur d'une ligne dans le planning
  ROW_HEIGHT: 30,
  // Largeur de la scrollbar
  SCROLLBAR_WIDTH: 20,
};
